import { collection, onSnapshot, query, where } from "firebase/firestore";
import { createContext, useContext, useEffect, useState } from "react";
import { db, realtimeDB } from "../firebase";
import { onValue, ref } from "firebase/database";

const userChatsContext = createContext();

export function UserChatsContextProvider({children}){
    const [countChats, setChats] = useState(0);
    const [categories,setCategories] = useState({});

    useEffect(()=>{
        const qu = query(collection(db,"supportChats"), where("setAdminStatus", "==", true))
        const unsubsribe = onSnapshot(qu,(querySnapshot)=>{
            setChats(querySnapshot.size)
        })

        const catRef = ref(realtimeDB, "categories");
        onValue(catRef, (snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            setCategories(data);
          }
        });
        return () => {
            unsubsribe()
        }
    },[])

    return (
        <userChatsContext.Provider value={{countChats,categories}}>
            {children}
        </userChatsContext.Provider>
    )
}

export function useUserChats(){
    return useContext(userChatsContext)
}
